import { IconFilledDatabase, IconWorkHome } from "@/assets/icons";
import { IconConstruction } from "@/assets/icons/IconConstruction";
import { IconDashboard } from "@/assets/icons/IconDashboard";
import { EMenuId } from "@/constants/enum";
import { AppRoutes, DashboardRoutes, MasterDataRoutes, OrganizationRoutes, SystemSettingsRoutes } from "@/routes/config";
import { TMenu } from "@/types/menu";

export const menus: TMenu[] = [
  {
    id: EMenuId.HOME,
    text: "ダッシュボード",
    icon: IconDashboard,
    path: AppRoutes.home,
    relatedRoutes: DashboardRoutes,
  },
  {
    id: EMenuId.CS_FUNCTIONS,
    text: "CS機能",
    children: [
      {
        text: "組織管理",
        icon: IconWorkHome,
        path: AppRoutes.organizations,
        relatedRoutes: OrganizationRoutes,
      },
    ],
  },
  {
    id: EMenuId.SYSTEM_MANAGEMENT,
    text: "システム管理",
    children: [
      {
        text: "マスターデータ管理",
        icon: IconFilledDatabase,
        path: AppRoutes.masterData,
        relatedRoutes: MasterDataRoutes,
      },
      {
        text: "システム設定",
        icon: IconConstruction,
        path: AppRoutes.systemSettings,
        relatedRoutes: SystemSettingsRoutes,
      },
    ],
  },
] as const;
